export default __webpack_public_path__ + "static/media/avatar.2e46a043.svg";